import * as React from 'react'

interface Props {
  color?: string
  className?: string
  style?: any
}

export const LogoHorizontalIcon = (props: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={211} height={38} viewBox="0 0 211 38" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.128 6.62c3.64 3.49 11.39 3.471 15.216 0 2.015-1.827 3.488-.241 4.762.124 1.273.366 1.239.61 5.302 1.168 4.064.558 5.97.645 6.967 3.435.758 2.118 2.098 10.08 2.098 10.08l-4.508-6.589s-3.973.438-10.615 9.467c-2.613 3.552-4.916 5.06-7.42 6.65-1.059.672-2.465 1.224-3.567 1.302-1.407.099-2.616-.36-4.052-1.139-4.042-2.19-6.136-5.027-8.01-7.466-6.208-8.074-10.793-8.814-10.793-8.814L0 21.428s1.34-7.963 2.098-10.081C3.095 8.557 5 8.47 9.064 7.912c4.064-.559 4.03-.802 5.303-1.168 1.273-.365 2.791-2.012 4.761-.124z"
      fill="#61948A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.62 7.422c3.59 3.033 11.233 3.016 15.007 0 1.986-1.588 3.44-.21 4.695.107 1.256.318 1.222.53 5.23 1.015 4.007.485 5.886.56 6.87 2.985.748 1.842 2.069 8.762 2.069 8.762l-4.446-5.727s-3.687.354-10.238 8.201c-4.799 5.615-7.918 7.624-9.74 8.301-1.064.396-2.758.39-3.723.058-1.797-.616-4.959-2.573-9.903-8.359-6.551-7.847-10.239-8.201-10.239-8.201L.757 20.29s1.321-6.92 2.068-8.762c.984-2.424 2.863-2.5 6.87-2.985 4.009-.485 3.974-.697 5.23-1.015 1.256-.317 2.753-1.749 4.696-.107z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.915 15.297s.983-2.127 1.245-2.816c.262-.688.85-1.06 3.415-1.226 2.566-.166 7.113-.699 7.113-.699l-2.451 5.962s-4.908-4.213-6.368-4.294c-1.459-.081-2.954 3.073-2.954 3.073z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.262 12.357a.67.67 0 0 1 .218-.14c.59-.203 6.442.965 7.988 1.28l-1.243 3.022s-4.908-4.213-6.367-4.294c-.2-.01-.4.038-.596.132z"
      fill="#264841"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.477 12.4c-.243-.103-.453-.166-.62-.175a1.235 1.235 0 0 0-.595.132.67.67 0 0 1 .218-.14c.59-.203 6.442.965 7.988 1.28l-.133.324c-1.363-.299-5.932-1.294-6.782-1.41a12.75 12.75 0 0 0-.076-.01z"
      fill={props.color || '#7CE5CF'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.746 15.297s-.983-2.127-1.245-2.816c-.262-.688-.85-1.06-3.416-1.226-2.565-.166-7.113-.699-7.113-.699l2.452 5.962s4.908-4.213 6.367-4.294c1.46-.081 2.955 3.073 2.955 3.073z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.4 12.357a.669.669 0 0 0-.22-.14c-.589-.203-6.44.965-7.987 1.28l1.243 3.022s4.908-4.213 6.367-4.294c.2-.01.4.038.596.132z"
      fill="#264841"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.184 12.4c.243-.103.453-.166.62-.175.199-.01.399.038.595.132a.669.669 0 0 0-.218-.14c-.59-.203-6.442.965-7.988 1.28l.134.324c1.363-.299 5.931-1.294 6.782-1.41l.075-.01z"
      fill={props.color || '#7CE5CF'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m22.984 10.74 1.064 6.745s-.782-1.655-1.877-2.356c-1.326-1.069-3.607-.15-5.474-1.581-.719-.393-1.077-1.07-1.253-1.713 1.116-1.888 2.168-2.272 2.168-2.272l5.372 1.176zm8.28 0 5.372-1.177s1.052.384 2.168 2.272c-.175.643-.534 1.32-1.253 1.713-1.867 1.43-4.148.512-5.474 1.58-1.094.702-1.877 2.357-1.877 2.357-.582-2.288-.32-4.54 1.065-6.746z"
      fill="#264841"
    />
    <g filter="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.656 14.096s.581 1.084 3.004 1.145c2.422.062 3.128 2.328 3.128 2.328s-.495-.975-2.983-.72c-2.489.255-3.15-2.753-3.15-2.753zm21.014 0s-.58 1.084-3.004 1.145c-2.422.062-3.128 2.328-3.128 2.328s.495-.975 2.984-.72c2.488.255 3.148-2.753 3.148-2.753z"
        fill={props.color || '#7CE5CF'}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.072 12.487c.32.532.8 1.37 1.077 2.035.44 1.057.944 2.63 1.999 2.993 1.054.364 2.58.052 3.567.93.825.733.7 1.492 1.01 1.903.313.412 2 2.2 2 2.2h4.768s1.687-1.788 1.999-2.2c.311-.411.186-1.17 1.01-1.903.988-.878 2.513-.566 3.568-.93 1.055-.363 1.559-1.936 1.998-2.993.277-.664.758-1.503 1.077-2.035l.052.105c1.253 2.548 2.17 3.849.067 7.642-1.138 1.539-4.697 5.793-7.222 7.712-1.34 1.019-2.444 1.6-3.265 1.932-1.067.431-2.341.43-3.531-.081-.798-.343-1.834-.91-3.07-1.85-2.525-1.92-6.084-6.174-7.222-7.713-2.103-3.793-1.186-5.094.066-7.642a8.49 8.49 0 0 1 .052-.105zm6.989-1.95 2.01.44c2.073.313 4.102.332 6.076 0l1.675-.366c-.357.614-1.03 1.851-1.164 2.646-.434 2.573-.32 6.361-.32 6.361l-1.387 1.563h-3.976l-1.387-1.563s.113-3.788-.32-6.36c-.14-.829-.864-2.136-1.207-2.72z"
      fill="#000"
    />
    <path stroke={props.color || '#7CE5CF'} d="M63.991 0v38" />
    <path
      d="M88.46 26.28H80.6L79.34 30h-5.37l7.62-21.06h5.94L95.15 30h-5.43l-1.26-3.72zm-1.32-3.96-2.61-7.71-2.58 7.71h5.19zm18.22-13.38c2.22 0 4.16.44 5.82 1.32 1.66.88 2.94 2.12 3.84 3.72.92 1.58 1.38 3.41 1.38 5.49 0 2.06-.46 3.89-1.38 5.49-.9 1.6-2.19 2.84-3.87 3.72-1.66.88-3.59 1.32-5.79 1.32h-7.89V8.94h7.89zm-.33 16.62c1.94 0 3.45-.53 4.53-1.59s1.62-2.56 1.62-4.5-.54-3.45-1.62-4.53-2.59-1.62-4.53-1.62h-2.43v12.24h2.43zm27.347.72h-7.86l-1.26 3.72h-5.37l7.62-21.06h5.94l7.62 21.06h-5.43l-1.26-3.72zm-1.32-3.96-2.61-7.71-2.58 7.71h5.19zm21.023 2.407c0-.577-.079-1.09-.235-1.538a3.17 3.17 0 0 0-.776-1.231c-.361-.361-.855-.698-1.48-1.01-.615-.323-1.377-.64-2.285-.953a18.998 18.998 0 0 1-2.431-.996 8.344 8.344 0 0 1-1.846-1.245 4.857 4.857 0 0 1-1.172-1.64c-.264-.626-.396-1.358-.396-2.198 0-.83.147-1.582.44-2.256a5.186 5.186 0 0 1 1.26-1.758 5.632 5.632 0 0 1 1.904-1.128c.732-.263 1.543-.395 2.432-.395 1.269 0 2.363.288 3.281.864a5.707 5.707 0 0 1 2.139 2.3c.498.957.747 2.026.747 3.208h-1.67c0-.928-.176-1.753-.528-2.476a3.887 3.887 0 0 0-1.523-1.699c-.664-.42-1.475-.63-2.432-.63-.957 0-1.762.181-2.417.542-.644.352-1.128.825-1.45 1.421a3.977 3.977 0 0 0-.483 1.948c0 .508.078.977.234 1.407.156.43.415.825.776 1.186.372.361.86.703 1.465 1.026.606.312 1.338.605 2.198.879a16.56 16.56 0 0 1 2.548 1.04c.743.37 1.363.81 1.861 1.318a4.855 4.855 0 0 1 1.142 1.728c.264.655.396 1.407.396 2.256 0 .88-.152 1.665-.454 2.359a5.017 5.017 0 0 1-1.289 1.758 5.844 5.844 0 0 1-1.963 1.098c-.752.254-1.582.381-2.49.381a8.158 8.158 0 0 1-2.388-.366 6.605 6.605 0 0 1-2.168-1.143c-.645-.517-1.162-1.181-1.553-1.992-.391-.81-.586-1.777-.586-2.9h1.685c0 .888.146 1.645.439 2.27.303.615.694 1.113 1.172 1.494a4.849 4.849 0 0 0 1.611.82 6.69 6.69 0 0 0 1.802.25c.918 0 1.709-.166 2.373-.498.674-.333 1.192-.796 1.553-1.392.371-.605.557-1.309.557-2.11zm10.078-.396 3.823-15.66h1.318l-.981 4.688L162.231 30h-1.274l1.201-5.669zm-4.351-15.66L161 24.186l.953 5.815h-1.319l-4.526-21.328h1.699zm14.605 15.499 3.149-15.498h1.699L172.734 30h-1.318l.996-5.83zM167.46 8.672l3.765 15.66L172.412 30h-1.275l-3.984-16.64-.996-4.688h1.303zm18.648 1.289L179.956 30h-1.729l6.782-21.328h1.187l-.088 1.289zM191.616 30l-6.153-20.04-.073-1.288h1.172L193.359 30h-1.743zm-.952-7.544v1.582h-9.624v-1.582h9.624zm12.085-1.128h-5.054v-1.582h5.054c1.044 0 1.889-.205 2.534-.615a3.644 3.644 0 0 0 1.406-1.685c.303-.713.454-1.509.454-2.387 0-.86-.151-1.656-.454-2.388a3.78 3.78 0 0 0-1.406-1.758c-.645-.45-1.49-.674-2.534-.674h-4.512V30h-1.685V8.672h6.197c1.318 0 2.426.268 3.325.806a5.12 5.12 0 0 1 2.051 2.24c.468.958.703 2.066.703 3.326 0 1.308-.235 2.436-.703 3.384a4.81 4.81 0 0 1-2.051 2.153c-.899.498-2.007.747-3.325.747z"
      fill={props.color || '#7CE5CF'}
    />
    <defs>
      <filter
        id="a"
        x={16.185}
        y={13.625}
        width={21.956}
        height={4.414}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={0.235} result="effect1_foregroundBlur_228_4540" />
      </filter>
    </defs>
  </svg>
)
